import React from 'react';
import WorkforceResourceOptimizationPage from './WorkforceResourceOptimizationPage';

const ResourceOptimizationAllocationsPage = () => {
  return <WorkforceResourceOptimizationPage initialTab="allocations" showTopTabs={false} />;
};

export default ResourceOptimizationAllocationsPage;

